import {MouseEvent, TouchEvent} from 'react';
import {FilterNodeRangeApplyButton} from './FilterNodeRangeApplyButton';
import {FilterNodeRangeCancelButton} from './FilterNodeRangeCancelButton';
import {css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';

interface Props {
  onDatePickerClear: () => void;
  onDatePickerClose: (e: MouseEvent | TouchEvent) => void;
  isResetFiltersButtonDisabled?: boolean;
}

export const FilterNodeRangeActionButtons = (props: Props) => {
  const {onDatePickerClose, onDatePickerClear, isResetFiltersButtonDisabled} = props;

  const theme = useTheme();
  const muiStyles = getStyles({theme});

  return (
    <div css={muiStyles.actionButtons}>
      <FilterNodeRangeApplyButton onDatePickerClose={onDatePickerClose} />
      <FilterNodeRangeCancelButton onDatePickerClear={onDatePickerClear} disabled={isResetFiltersButtonDisabled} />
    </div>
  );
};

const getStyles: GetStylesFunction = (options) => ({
  actionButtons: css`
    display: flex;
    gap: ${options?.theme?.spacing(1)};
  `,
});
